define('views/modules/member/select/member-select-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // Views
    'views/parts/panel/base-panel',
    'views/modules/member/select/member-select-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VBasePanel,
    VMemberSelectContent
) {

    var VMemberSelectPanel = VBasePanel.extend({
        header: {
            title: "general:Client selection",
            subtitle: "general:Select a client",
        },
        buttons: { back: 'close' },
        tabs: [{ id: 'select', title: 'Client', icon: 'sl-icon-edit', active: true }],
        content: {
            select: VMemberSelectContent
        },
        defaultView: 'select',

        initialize: function(opt) {
            var select = this.getView('select',
                _.pick(opt, ['group', 'customActions'])
            );
            this.listenTo(select, { 'selected:confirm': this.onSelectedConfirm });
        },

        ////////////
        // events //
        ///////////

        onSelectedConfirm: function(collection) {
            this.trigger('selected:confirm', collection);
            this.close();
        },

    });

    return VMemberSelectPanel;
});

